module.exports = __webpack_public_path__ + "img/hd.4d569f5c.png";